module.exports = __webpack_public_path__ + "static/media/brasil.45dda5a1.JPG";